<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-my-projects">
  <div class="org-admin-my-projects--layout">
    <app-org-admin-sidebar class="org-admin-my-projects--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-my-projects--content">
      <app-page-header></app-page-header>
      <app-my-project></app-my-project>
    </div>
  </div>
</div>
